
define('jst!filefinder/_account',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<li class="<%= account.provider %>-tab"  data-tab-name="<%= account.provider %>">\n  <div class="image-block">\n    <div class="img space-right"><div class="icon-16 icon-16-integration-<%= account.icon %>"></div></div>\n    <div class="img-ext"></div>\n    <div class="bd"><span><%= account.provider_humanized_name %></span></div>\n  </div>\n</li>');
 });

